module.exports = __webpack_public_path__ + "static/media/Shaiv.1859bd23.jpg";